// Imports
import React from 'react';
import styled from 'styled-components/macro';
import { View } from '..';
import plansDetails from '../../../../shareables/front-end/subscription-plans/plans-details';
import planMapping from '../../../../shareables/utils/billing/plan-mapping';
import FreePlan from './free-plan';
import PaidPlan from './paid-plan';


// Styled components
const MainPlans = styled.div`
	display: grid;
	align-items: end;
	justify-content: center;
	gap: 1.25rem;
	grid-auto-flow: column;
	
	padding-top: 1.875rem;
	
	@media (max-width: 48rem) {
		grid-auto-flow: row;
		align-items: center;
	}
`;


// Define the accepted props
interface Props {
	view: View;
	sizeIndex: number;
	setSizeIndex: React.Dispatch<React.SetStateAction<number>>;
}


// Function component
const Plans: React.FC<Props> = (props) => (
	<React.Fragment>
		<MainPlans>
			{plansDetails.paidPlans.map((paidPlan) => (
				<PaidPlan
					key={paidPlan.name}
					{...paidPlan}
					{...props}
					mostPopular={paidPlan.planNumber === planMapping.engage}
				/>
			))}
		</MainPlans>
		
		<FreePlan />
	</React.Fragment>
);

export default Plans;
